module.exports = __webpack_public_path__ + "media/images/riders/EDWARD_MASTERS-ff4b841b24e5a8d249535222ad0c6373.png";